import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface SortControlsProps {
  sortBy: string;
  setSortBy: (value: string) => void;
  sortOrder: string;
  setSortOrder: (value: string) => void;
}

export function SortControls({ sortBy, setSortBy, sortOrder, setSortOrder }: SortControlsProps) {
  return (
    <div className="flex items-center gap-2">
      <Select value={sortBy} onValueChange={setSortBy}>
        <SelectTrigger className="w-[90px] h-8 text-xs">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="name">Name</SelectItem>
          <SelectItem value="released">Release Date</SelectItem>
          <SelectItem value="set">Set/Number</SelectItem>
          <SelectItem value="rarity">Rarity</SelectItem>
          <SelectItem value="color">Color</SelectItem>
          <SelectItem value="usd">Price: USD</SelectItem>
          <SelectItem value="tix">Price: TIX</SelectItem>
          <SelectItem value="eur">Price: EUR</SelectItem>
          <SelectItem value="cmc">Mana Value</SelectItem>
          <SelectItem value="power">Power</SelectItem>
          <SelectItem value="toughness">Toughness</SelectItem>
          <SelectItem value="artist">Artist Name</SelectItem>
          <SelectItem value="edhrec">EDHREC Rank</SelectItem>
          <SelectItem value="review">Set Review</SelectItem>
        </SelectContent>
      </Select>
      <Select value={sortOrder} onValueChange={setSortOrder}>
        <SelectTrigger className="w-[110px] h-8 text-xs">
          <SelectValue placeholder="Order" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="auto">Auto</SelectItem>
          <SelectItem value="asc">Ascending</SelectItem>
          <SelectItem value="desc">Descending</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
